import push from '../utils/push';

/** @typedef {import('./product-datalayer').GAProduct} GAProduct */

/**
 * @param {string} currencyCode 
 * @param {GAProduct} product 
 */
function sendProductDetailView(currencyCode, product) {
    push({
        'event': 'product-detail-view',
        'ecommerce': {
            'currencyCode': currencyCode,
            'detail': {
                'actionField': {},
                'products': [product]
            }
        }
    });
}

window.VCA = window.VCA || {};

window.VCA.productDetailsDatalayer = {
    sendProductDetailView
};

export {
    sendProductDetailView
};
